import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorkspaceOptional } from '../context/WorkspaceContext';

/**
 * Navigation that keeps the focused workspace window in sync with the browser URL.
 * Falls back to standard react-router navigate outside workspace mode.
 */
export function useWorkspaceNavigate() {
  const workspace = useWorkspaceOptional();
  const navigate = useNavigate();

  return useCallback((to, options) => {
    if (workspace?.navigateInFocusedWindow) {
      workspace.navigateInFocusedWindow(to, options);
      return;
    }
    navigate(to, options);
  }, [workspace, navigate]);
}

export default useWorkspaceNavigate;